import Tag from 'src/modules/shared/components/atoms/tag';
import type { ConversationFooterTagBadgeProps } from 'src/modules/communications/types/conversation-card.type';
import { ConversationFooterStatusTag } from '../../../atoms/conversation-footer-status-tag';
import { TestConversationBadge } from '../../test-conversations/test-conversation-badge';

/**
 * Renders the existing compact badge for a derived conversation label.
 * @param props - Footer label, tint, and optional status.
 * @returns The matching test, status, or attention badge.
 */
export const ConversationFooterTagBadge = ({
  tag,
}: ConversationFooterTagBadgeProps) => {
  if (tag.key === 'test') {
    return (
      <TestConversationBadge size="xs" className="overflow-hidden shrink-0" />
    );
  }
  if (tag.status) return <ConversationFooterStatusTag status={tag.status} />;
  return (
    <Tag
      content={tag.label}
      size="xs"
      variant={tag.variant}
      appearance="soft"
      className="overflow-hidden shrink-0"
    />
  );
};
